// extracted by mini-css-extract-plugin
module.exports = {"AdminSpectacles":"adminSpectacles_AdminSpectacles__23EYI"};